import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function SAMLSSO() {
  const { domain } = useParams<{ domain: string }>();

  useEffect(() => {
    if (!domain) {
      return;
    }
    window.location.href = `/api/iam/v1/saml/${encodeURIComponent(domain)}/SSO`;
  }, [domain]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
        <p className="mt-4 text-gray-600">正在跳转到 SSO 登录页面...</p>
      </div>
    </div>
  );
}
